export enum UserPreferenceKeysEnum {
    HideWelcomeModal = 1,
}
